import axios from 'axios';

export function getEmailsForVesselComposition(filters) {
    const {
        vessel, emailId, approved, page, params,
    } = filters;
    return axios({
        method: 'POST',
        url: `/api/v1/mails/vesselComposition/${vessel._id || ''}`,
        withCredentials: true,
        data: {
            emailId,
            approved,
            page,
            params,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function approveVesselSize(vesselId, emailIds, field, sizeIds) {
    return axios({
        method: 'POST',
        url: `/api/v1/mails/vesselComposition/${vesselId}/approve`,
        data: {
            emailIds,
            field,
            sizeIds,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function rejectVesselSize(vesselId, emailIds, field, sizeIds, reason) {
    return axios({
        method: 'POST',
        url: `/api/v1/mails/vesselComposition/${vesselId}/reject`,
        data: {
            emailIds,
            field,
            sizeIds,
            reason,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

/**
 * 
 * @param {CompositionFilters} filters 
 */
export function getVesselsCompositions(filters) {
    return axios({
        method: 'POST',
        url: '/api/v1/mails/vesselComposition',
        data: filters,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

/**
 * @typedef {{ vesselId?: string, emailId?: string, page: number, limit: number }} CompositionFilters
 */



// WEBPACK FOOTER //
// ./app/services/vessels/composition.js